import { render, staticRenderFns } from "./Tipos.vue?vue&type=template&id=42aadeaa&"
import script from "./Tipos.vue?vue&type=script&lang=js&"
export * from "./Tipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports